<template>
  <div>
    <div class="project-map-container">
      <l-map ref="map" :zoom="zoom" :center="center" :options="mapOptions">
        <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base" name="OpenStreetMap" :attribution="attribution"></l-tile-layer>
        <!-- Overlay container -->
        <div class="overlay absolute md:w-[366px] w-full md:mx-3 mx-0 md:px-0 px-2.5 cursor-default top-[66px] md:top-20" id="overlay-search-presentation">
          <!-- Search card -->
          <transition name="project-info-card2">
            <div v-if="showSearch" class="relative p-4 bg-white m project-search md:left-0 md:right-0 md:top-0 rounded-3xl">
              <ellevio-web-map-search-input
                ref="autocomplete-input"
                class="flex justify-end w-full"
                :number-of-items="5"
                :show-autocomplete-list="true"
                :close-fullscreen="mobileFullscreen"
                :translations="{ ...translationsParsed.search, ...translationsParsed.summary }"
                :showAllCounties="props.showAllCounties"
                @searchfield-open="moveLocationSearch"
                @autocomplete-click="setViewToLocation"
                @search-mobile-fullscreen="handleCloseMobileSearch" />
              <div class="relative overlay">
                <a
                  v-if="mobileFullscreen"
                  @click="setViewToUserLocation"
                  href="#"
                  title="Min positon"
                  aria-role="button"
                  aria-label="Min positon"
                  aria-disabled="false"
                  class="flex items-center justify-center text-lg !text-black md:hidden"
                  :class="myLocationSearch ? 'mt-60' : 'mt-5'">
                  <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                      <path
                        stroke="#2C2827"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4.469 10.043c-1.127-.4-1.69-.601-1.859-.905a.917.917 0 0 1-.018-.851c.155-.312.71-.536 1.818-.985l10.452-4.23c1.092-.442 1.638-.664 1.984-.55a.99.99 0 0 1 .632.632c.113.345-.108.891-.55 1.984l-4.23 10.452c-.45 1.109-.674 1.663-.985 1.818a.917.917 0 0 1-.85-.018c-.305-.168-.505-.732-.907-1.859l-1.227-3.45c-.078-.22-.117-.33-.181-.42a.834.834 0 0 0-.208-.209c-.092-.064-.201-.103-.42-.18l-3.451-1.229Z" />
                    </svg>
                  </span>
                  {{ translationsParsed.controls.myLocation }}
                </a>
              </div>
              <!-- Background fullscreen and close/back to map link on mobile -->
              <div v-if="mobileFullscreen" class="fixed top-0 bottom-0 left-0 right-0 bg-white md:bg-transparent md:hidden md:left-auto md:right-auto md:top-auto">
                <div id="map-back-bar" class="flex items-center bg-gray-ultralight h-[56px] group pl-6 absolute top-0 w-full justify-start map-top-border pointer-events-none">
                  <button @click.prevent="backToMap" class="!pointer-events-auto inline-block text-lg !text-black font-futuraEfBook"><ellevio-web-link-icon-left-small class="inline-block mb-0.5" /> {{ translationsParsed.search.backToMap }}</button>
                </div>
              </div>
              <!-- Expandable Project Summary -->
              <transition name="expand" v-if="isMobileSize">
                <div v-if="expanded" class="project-summary">
                  <ellevio-web-map-summray-info :translations="translationsParsed.summary" :items="projects" class="block procjet-summary"> </ellevio-web-map-summray-info>
                  <!-- Toggle Button -->
                </div>
              </transition>
              <button v-if="isMobileSize" @click="expanded = !expanded" class="flex flex-row items-center gap-2 pt-4 btn-flow"><img :width="20" :height="20" :src="dispandExpandIcon()" />{{ expanded ? 'Visa mindre' : 'Visa mer' }}</button>
            </div>
          </transition>
          <div class="relative mt-5">
            <!-- Cards  -->
            <transition name="project-summary-card">
              <ellevio-web-map-summray-info v-if="!isMobileSize && !selectedMarker" :translations="translationsParsed.summary" :items="projects" class="block p-4 mt-5 procjet-summary"> </ellevio-web-map-summray-info>
            </transition>
            <!-- Project status summury card -->
            <!-- Project info -->
            <transition name="project-info-card">
              <div v-if="selectedMarker" style="max-height: calc(100dvh - 66px)" class="fixed bottom-2 left-2.5 md:left-0 md:right-0 right-2.5 p-5 bg-white md:top-0 project-info md:absolute md:bottom-auto top-auto overflow-auto rounded-3xl">
                <ellevio-web-map-item-info @close-item-info="unselectMarker" :translations="translationsParsed.info" :item="selectedMarker" :inStyleguide="inStyleGuide"></ellevio-web-map-item-info>
              </div>
            </transition>
          </div>
        </div>
        <l-marker v-for="(point, index) in projects" :key="index" :lat-lng="[point.coordinates.latitude, point.coordinates.longitude]" @click="handelMarkerClick(point, $event)">
          <l-icon
            v-if="point.projectState === 'Ongoing'"
            :icon-anchor="selectedMarker && selectedMarker.id === point.id ? [23, 62] : [13, 40]"
            :icon-size="selectedMarker && selectedMarker.id === point.id ? [57, 64] : [34, 38]"
            :icon-url="selectedMarker && selectedMarker.id === point.id ? iconUrlOngoingSelected : iconUrlOngoing"
            :className="selectedMarker && selectedMarker.id === point.id ? `marker-icon-${index} id-marker-icon-${point.id}` : `id-marker-icon-${point.id}`">
          </l-icon>
          <l-icon
            v-if="point.projectState === 'Planned'"
            :icon-anchor="selectedMarker && selectedMarker.id === point.id ? [23, 62] : [13, 40]"
            :icon-size="selectedMarker && selectedMarker.id === point.id ? [57, 64] : [34, 38]"
            :icon-url="selectedMarker && selectedMarker.id === point.id ? iconUrlPlannedSelected : iconUrlPlanned"
            :className="selectedMarker && selectedMarker.id === point.id ? `id-marker-icon-marker-icon-${index} ${point.id}` : `id-marker-icon-${point.id}`">
          </l-icon>
          <l-icon
            v-if="point.projectState === 'Finished'"
            :icon-anchor="selectedMarker && selectedMarker.id === point.id ? [23, 62] : [13, 40]"
            :icon-size="selectedMarker && selectedMarker.id === point.id ? [57, 64] : [34, 38]"
            :icon-url="selectedMarker && selectedMarker.id === point.id ? iconUrlFinishedSelected : iconUrlFinished"
            :className="selectedMarker && selectedMarker.id === point.id ? `marker-icon-${index} id-marker-icon-${point.id}` : `id-marker-icon-${point.id}`">
          </l-icon>
        </l-marker>
        <l-polygon v-for="(polygon, index) in polygons" :key="index" :lat-lngs="polygon" :stroke="stroke" :weight="1" color="#085c3b"></l-polygon>
        <l-control-attribution position="bottomright" prefix=""></l-control-attribution>
        <l-control-zoom v-if="!mobileFullscreen" class="hidden" :options="zoomOptions" position="bottomright" />
        <!-- Modal info about project map -->
        <button
          v-if="!mobileFullscreen"
          type="button"
          :title="translationsParsed.controls.about"
          @click="handleInfoModal"
          class="overlay absolute right-0 w-[52px] h-[52px] top-2 md:top-[76px] mx-3 px-0 bg-white md:flex items-center justify-center hidden rounded-full"
          style="box-shadow: 0px 4px 4px 0px #00000040">
          <svg xmlns="http://www.w3.org/2000/svg" width="4" height="22" fill="none">
            <path fill="#F5F5F5" d="M0 0h4v22H0z" />
            <path fill="#000" d="M3.292 21.693H.384v-14.7h2.908zm0-18.2H.384v-2.8h2.908z" />
          </svg>
        </button>
        <button id="map-info-modal-button" @click.prevent="handleInfoModal" class="overlay !pointer-events-auto absolute right-3 font-futuraEfBook top-[15px] inline-block text-lg mr-3 !text-black underline md:hidden">
          {{ translationsParsed.controls.about }}
        </button>
        <!-- End modal info about project map -->
        <l-control v-if="!mobileFullscreen" position="bottomright" class="leaflet-location leaflet-control">
          <a @click="setViewToUserLocation" href="#" :title="translationsParsed.controls.myLocation" aria-role="button" :aria-label="translationsParsed.controls.myLocation" aria-disabled="false">
            <span aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                <path
                  stroke="#2C2827"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5.363 12.052c-1.353-.48-2.03-.722-2.23-1.086a1.1 1.1 0 0 1-.022-1.022c.185-.373.85-.643 2.181-1.181l12.543-5.077c1.31-.53 1.966-.796 2.38-.66.359.118.64.4.759.76.136.413-.13 1.069-.66 2.38l-5.077 12.542c-.538 1.33-.808 1.996-1.18 2.182a1.1 1.1 0 0 1-1.022-.022c-.365-.202-.606-.878-1.087-2.23l-1.474-4.141c-.093-.263-.14-.395-.216-.505a1 1 0 0 0-.25-.25c-.11-.076-.242-.123-.505-.216l-4.14-1.474Z" />
              </svg>
            </span>
          </a>
        </l-control>
      </l-map>
    </div>
  </div>
</template>

<script setup>
import { useFetch } from '../../../helpers/fetch'
import { ref, onMounted, defineProps, computed, nextTick } from 'vue'
import EllevioWebMapSearchInput from '../vue-components/MapSearchInput.vue'
import EllevioWebMapItemInfo from '../vue-components/MapItemInfo.vue'
import EllevioWebMapSummrayInfo from '../vue-components/MapSummaryInfo.vue'
import EllevioWebLinkIconLeftSmall from '../structure/LinkIconLeftSmall.vue'
import polygons from '../../../helpers/polygons'
import store from '../../../store/web'
import countyList from '../../../helpers/counties.js'

import 'leaflet/dist/leaflet.css'
import { latLngBounds } from 'leaflet'
import { LControlZoom, LControl, LMap, LTileLayer, LMarker, LIcon, LControlAttribution, LPolygon } from '@vue-leaflet/vue-leaflet'

// Data
const projects = ref(null)
const selectedMarker = ref(null)
const map = ref(null)
const mobileFullscreen = ref(false)
const myLocationSearch = ref(false)

const expanded = ref(false)
// Props
const props = defineProps({
  translations: {
    type: Object,
    default: () => {}
  },
  openstreetmap: {
    type: Boolean,
    default: true
  },
  cartdb: {
    type: Boolean,
    default: false
  },
  apiUrl: {
    type: String,
    default: '/api/projectmapdata'
  },
  showAllCounties: {
    type: Boolean,
    default: false
  }
})

const baseUrl = computed(() => {
  let env = {}
  try {
    env = import.meta.env
    if (typeof env !== 'object') env = {}
  } catch (_) {
    env = {}
  }

  return env.VITE_VUE_APP_BASE_URL ?? ''
})

const translationsParsed = computed(() => {
  const translations = props.translations ?? {}

  if (!translations?.search) translations.search = {}
  if (!translations?.info) translations.info = {}
  if (!translations?.summary) translations.summary = {}
  if (!translations?.controls) translations.controls = {}
  if (!translations?.modal) translations.modal = {}

  return translations
})

const inStyleGuide = computed(() => baseUrl.value?.includes('localhost'))

// Leaflet settings
const zoom = ref(5)
const center = ref([59.625767, 14.632807])
const iconUrlOngoing = inStyleGuide.value ? '/src/assets/images/project-map-ongoing-marker.svg' : '/gui-web/img/project-map-ongoing-marker.svg'
const iconUrlOngoingSelected = inStyleGuide.value ? '/src/assets/images/project-map-ongoing-marker-selected.svg' : '/gui-web/img/project-map-ongoing-marker-selected.svg'
const iconUrlPlanned = inStyleGuide.value ? '/src/assets/images/project-map-planned-marker.svg' : '/gui-web/img/project-map-planned-marker.svg'
const iconUrlPlannedSelected = inStyleGuide.value ? '/src/assets/images/project-map-planned-marker-selected.svg' : '/gui-web/img/project-map-planned-marker-selected.svg'
const iconUrlFinished = inStyleGuide.value ? '/src/assets/images/project-map-finished-marker.svg' : '/gui-web/img/project-map-finished-marker.svg'
const iconUrlFinishedSelected = inStyleGuide.value ? '/src/assets/images/project-map-finished-marker-selected.svg' : '/gui-web/img/project-map-finished-marker-selected.svg'
const attribution = '<a href="https://www.openstreetmap.org/copyright" target="blank">©OpenStreetMap</a>'
const stroke = ref(true)

const mapOptions = {
  zoomControl: false, // Disabling the default zoom control
  attributionControl: false
}

// Hide search in mobile when a marker i selecte
const showSearch = computed(() => {
  return window.innerWidth <= 767 && selectedMarker.value ? false : true
})

const dispandExpandIcon = () => {
  if (expanded.value) {
    return inStyleGuide.value ? '/src/assets/images/minus.svg' : '/gui-web/img/minus.svg'
  } else {
    return inStyleGuide.value ? '/src/assets/images/plus.svg' : '/gui-web/img/plus.svg'
  }
}

// Function show or hide components if search is active in mobile and if search results is shown full screen i mobile
const handleCloseMobileSearch = (closeOpen) => {
  if (window.innerWidth <= 767) {
    mobileFullscreen.value = closeOpen
  }
}

const isMobileSize = computed(() => {
  return window.innerWidth <= 767
})

// close fullscreen
const backToMap = (event) => {
  event.preventDefault()
  mobileFullscreen.value = false
}

// move location under searchfield
const moveLocationSearch = (newVal) => {
  myLocationSearch.value = newVal
}

// Function callculate the map center and zoom level based om map markers
const fitMapToMarkers = () => {
  if (map.value) {
    const bounds = latLngBounds()
    projects.value.forEach((point) => {
      // bounds.extend([point.Coordinates.Latitude, point.Coordinates.Longitude])
      if (window.innerWidth <= 767) {
        bounds.extend([point.coordinates.latitude + 1.6, point.coordinates.longitude])
      }
      bounds.extend([point.coordinates.latitude + 0.2, point.coordinates.longitude])
    })
    map.value.leafletObject?.fitBounds(bounds)
  }

  // Adjust the delay to slow down the initial zoom effect
  /*
  setTimeout(() => {
    map.value.leafletObject?.fitBounds(bounds, { zoom: 5, duration: 6 })
  }, 8000) // 1000 milliseconds delay before fitting the map
  */
}

const zoomOptions = {
  zoomInTitle: translationsParsed.value.controls.zoomIn,
  zoomOutTitle: translationsParsed.value.controls.zoomOut,
  zoomInText:
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.0383 11.092L22.3841 11.092L22.3841 13.1498L1.61597 13.1498L1.61597 11.092L10.9615 11.092L10.9615 1.83218L13.0383 1.83218L13.0383 11.092ZM10.9615 22.4097L10.9615 14.7938L13.0383 14.7938V22.4097L10.9615 22.4097Z" fill="black"/></svg>',
  zoomOutText: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.61595 10.9226L22.384 10.9226L22.384 12.9994L1.61595 12.9994L1.61595 10.9226Z" fill="black"/></svg>'
}

const setViewToUserLocation = () => {
  mobileFullscreen.value = false
  map.value.leafletObject.locate({ setView: true, maxZoom: 16 })
}

const setViewToLocation = (point) => {
  stroke.value = false
  map.value.leafletObject.flyTo([point.lat, point.lon], point.isCity ? 14 : 11)
  //center.value = [coordinates.lat, coordinates.lon]
}

// Handle click on marker
const handelMarkerClick = (item, event) => {
  if (item) {
    selectedMarker.value = { ...item }
    setTimeout(() => {
      document.getElementsByClassName(event.target.getIcon().options.className)[0].classList.add('marker-focus')
    }, 0)

    // Fly and zoom to Marker
    const mapInstance = map.value.leafletObject
    const { latitude, longitude } = item.coordinates
    const currentZoomLevel = map.value.leafletObject._zoom
    const zoomLevel = 15
    const duration = currentZoomLevel > 10 ? 0.5 : 2

    stroke.value = false

    //TODO: remove stroke during animation in programmatic way
    mapInstance.flyTo([latitude, longitude], zoomLevel, {
      animate: true,
      duration: duration // Fly animation duration
    })
  }
}

// Handle click on info button. TODO: Handle texts as translations
const handleInfoModal = () => {
  store.dispatch('modalOpen', {
    type: 'projectMap',
    modalName: translationsParsed.value.modal.name,
    content: translationsParsed.value.modal.content,
    wideLayout: true
  })
}

const unselectMarker = () => {
  selectedMarker.value = null
}

// Filter out duplicate projects
const filterDuplicateProjects = (projects) => {
  const filteredProjects = []

  projects.forEach((project) => {
    const isDuplicate = filteredProjects.some((item) => item.coordinates.latitude === project.coordinates.latitude && item.coordinates.longitude === project.coordinates.longitude && item.description === project.description && item.title === project.title)

    if (!isDuplicate) {
      filteredProjects.push(project)
    }
  })

  return filteredProjects
}

onMounted(async () => {
  const responseObject = await useFetch(`${baseUrl.value}${props.apiUrl}`)
  const response = responseObject?.response
  projects.value = filterDuplicateProjects(response.data.projects)

  // Add alt texts to marker icon images
  setTimeout(() => {
    const allMarkers = document.querySelectorAll('.leaflet-marker-icon')

    function getIdNumberFromClass(element) {
      const classList = element.classList
      for (let index = 0; index < classList.length; index++) {
        const className = classList[index]
        if (className.startsWith('id-marker-icon-')) {
          return className.replace('id-marker-icon-', '')
        }
      }
      return null
    }

    for (let index = 0; index < allMarkers.length; index++) {
      const element = allMarkers[index]
      const idNumber = getIdNumberFromClass(element)
      const matchingProject = projects.value.find((project) => project.id.toString() === idNumber)
      if (matchingProject) {
        element.alt = matchingProject.title
      }
    }
    const propagationId = 'overlay-search-presentation'
    L.DomEvent.disableClickPropagation(document.getElementById(propagationId)) // eslint-disable-line
  }, 0)

  // event listener
  map.value.leafletObject.on('moveend zoomend', function () {
    //reset stroke maybe
    stroke.value = true
  })
  nextTick(() => {
    // event listener
    map.value.leafletObject.on('moveend zoomend', function () {
      //reset stroke maybe
      stroke.value = true
    })

    // url params handling
    const urlParams = new URLSearchParams(window.location.search)
    const kartId = urlParams.get('kartid') === null ? -1 : urlParams.get('kartid')
    const kartLan = urlParams.get('kartlan')?.toLowerCase()

    if (kartId > -1) {
      let projectCounter = 0
      for (const item of projects.value) {
        projectCounter++
        if (item.id === Number(kartId)) {
          const { latitude, longitude } = item.coordinates
          const currentZoomLevel = map.value.leafletObject._zoom
          const zoomLevel = 15
          const duration = currentZoomLevel > 10 ? 0.5 : 2

          selectedMarker.value = { ...item }
          stroke.value = false
          map.value.leafletObject.flyTo([latitude, longitude], zoomLevel, {
            animate: true,
            duration: duration // Fly animation duration
          })
          break
        }
      }
      if (projectCounter === projects.value.length) {
        fitMapToMarkers()
      }
    } else if (kartLan) {
      const adjustedCounties = countyList.map((item) => {
        const adjustedItem = { ...item }
        adjustedItem.name = adjustedItem.County.includes('s län') ? item.County.replace('s län', '') : (adjustedItem.name = item.County.replace(' län', ''))

        return adjustedItem
      })

      const currentZoomLevel = map.value.leafletObject._zoom
      const latitude = adjustedCounties.find((item) => item.name.toLowerCase().includes(kartLan))?.Latitude
      const longitude = adjustedCounties.find((item) => item.name.toLowerCase().includes(kartLan))?.Longitude
      const duration = currentZoomLevel > 10 ? 0.5 : 2

      if (longitude && latitude) {
        stroke.value = false
        map.value.leafletObject.flyTo([latitude, longitude], 11, {
          animate: true,
          duration: duration // Fly animation duration
        })
      } else {
        fitMapToMarkers()
      }
    } else {
      fitMapToMarkers()
    }
  })
})
</script>

<style scoped>
.overlay {
  z-index: 1000;
}
.project-info {
  z-index: 1200;
}
.project-map-container {
  width: 100%;
  height: 100vh;
  height: 100dvh;
}

.leaflet-container :deep(.leaflet-control:not(.leaflet-control-attribution) a) {
  box-shadow: 0px 4px 4px 0px #00000040;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 0;
  border-radius: 0;
}

.leaflet-container :deep(.leaflet-control:not(.leaflet-control-attribution)) {
  border: 0;
  border-radius: 0;
}

.leaflet-container :deep(.leaflet-control:not(.leaflet-control-attribution) a:not(:last-child))::after {
  content: '';
  background: #c1c1c1;
  width: 34px;
  height: 1px;
  position: absolute;
  bottom: 48px;
  height: 2px;
}

.leaflet-container :deep(.leaflet-control-zoom) {
  display: none;
}

.leaflet-location {
  /*padding-bottom: calc(env(safe-area-inset-bottom) + 1px);*/
  bottom: 0;
}
/* Transition vue */

.project-info-card {
  animation: info-card-animation-up 0.3s ease-in-out;
}
.project-info-card2 {
  animation: info-card-animation-down 0.3s ease-in-out;
}

.project-info-card2-enter-active {
  animation: info-card-animation-down 0.3s ease-out;
}
.project-info-card2-leave-active {
  animation: info-card-animation-down 0.3s ease-in reverse;
}

.project-info-card-enter-active {
  animation: info-card-animation-up 0.3s ease-out;
}
.project-info-card-leave-active {
  animation: info-card-animation-up 0.3s ease-in reverse;
}

.project-summary-card-enter-active {
  animation: info-card-animation-up 0.3s ease-out;
}
.project-summary-card-leave-active {
  animation: info-card-animation-up 0.3s ease-in reverse;
}

.project-summary-card-enter-active {
  animation: info-card-animation-up 0.3s ease-out;
}
.project-summary-card-leave-active {
  animation: info-card-animation-up 0.3s ease-in reverse;
}

@media screen and (min-width: 768px) {
  .project-map-container {
    width: 100%;
    height: calc(100vh - 108px); /* minus heading and back link area */
  }
  .leaflet-location {
    bottom: 0;
  }
  .leaflet-container :deep(.leaflet-control:not(.leaflet-control-attribution)) {
    margin-right: 12px;
  }
  /* Transitons vue */
  .project-info-card-enter-active {
    animation: info-card-animation 0.3s ease-out;
  }
  .project-info-card-leave-active {
    animation: info-card-animation 0.3s ease-in reverse;
  }
  .leaflet-container :deep(.leaflet-control-zoom) {
    display: block;
  }

  .project-summary-card-enter-active {
    animation: info-card-animation 0.3s ease-out;
  }
  .project-summary-card-leave-active {
    animation: info-card-animation 0.3s ease-in reverse;
  }
}

@keyframes info-card-animation {
  from {
    transform: translateX(-576px);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes info-card-animation-up {
  from {
    transform: translateY(800px);
  }
  to {
    transform: translateY(0);
  }
}
/* @keyframes info-card-animation-down {
  from {
    transform: translateY(-800px);
  }
  to {
    transform: translateY(0);
  }
} */
</style>
